import React from "react";
import { NavBar as DSNav } from "widgets/NavBar";
import { NotificationDotType } from "widgets/NavBar/NotificationDot";
import { Menu } from "design_system/Menu";
import { NAV_MENU_V3_ENGAGEMENTS } from "./constants";
import { recordPatientAppClickEngagement } from "../../utils/engagements";
import { VerifyOrLogout, VerifyOrLogoutColor } from "./interfaces";

export interface MyAccountMenuDesktopProps {
    notificationCenterUrl: string;
    insuranceUrl: string | null;
    insuranceConsentUrl: string | null;
    verifyOrLogout: VerifyOrLogout | null;
    notifyAboutInvalidOrMissingContactInfo: boolean;
}

export const MyAccountMenuDesktop = ({
    notificationCenterUrl,
    insuranceUrl,
    insuranceConsentUrl,
    verifyOrLogout,
    notifyAboutInvalidOrMissingContactInfo,
}: MyAccountMenuDesktopProps) => (
    <Menu>
        <DSNav.TopBar.MenuButton
            className="hidden s768:flex"
            onClick={() =>
                recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.MY_ACCOUNT_DROPDOWN_BTN)
            }
        >
            <div className="flex">
                {gettext("My account")}
                {notifyAboutInvalidOrMissingContactInfo && (
                    <DSNav.NotificationDot
                        id="navbar-closed-desktop-invalid-or-missing-contact-dot"
                        type={NotificationDotType.DESKTOP_HEADER}
                    />
                )}
            </div>
        </DSNav.TopBar.MenuButton>
        <Menu.Items>
            <Menu.Item
                as="a"
                href={notificationCenterUrl}
                onClick={() =>
                    recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.MY_ACCOUNT_BTN)
                }
            >
                <div className="flex items-center">
                    {gettext("My account")}
                    {notifyAboutInvalidOrMissingContactInfo && (
                        <DSNav.NotificationDot
                            id="navbar-open-desktop-invalid-or-missing-contact-dot"
                            type={NotificationDotType.MENU_ITEM}
                        />
                    )}
                </div>
            </Menu.Item>
            {insuranceUrl && (
                <Menu.Item
                    as="a"
                    href={insuranceUrl}
                    onClick={() =>
                        recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.ADD_INSURANCE_BTN)
                    }
                >
                    {gettext("Add insurance")}
                </Menu.Item>
            )}
            {insuranceConsentUrl && (
                <Menu.Item
                    as="a"
                    href={insuranceConsentUrl}
                    onClick={() =>
                        recordPatientAppClickEngagement(
                            NAV_MENU_V3_ENGAGEMENTS.ADD_INSURANCE_APPROVAL_BTN,
                        )
                    }
                >
                    {gettext("Add insurance approval")}
                </Menu.Item>
            )}
            {verifyOrLogout && (
                <Menu.Item
                    as="a"
                    className={
                        verifyOrLogout.color === VerifyOrLogoutColor.PRIMARY
                            ? "text-primary-3667e9"
                            : "text-red-c34648"
                    }
                    href={verifyOrLogout.url}
                    onClick={() => recordPatientAppClickEngagement(verifyOrLogout.engagementTarget)}
                >
                    {verifyOrLogout.cta}
                </Menu.Item>
            )}
        </Menu.Items>
    </Menu>
);
